import { useMutation } from "@tanstack/react-query";
import httpClient from "../httpClient";
import { useNavigate } from "react-router-dom";

interface PaymentPayload {
  amount: number | string;
  corporate_subsidiary_id: number | string;
  payment_method_id: number | string;
  corporate_service_id: number | string;
  channel: string;
  instrument_account_owner?: string;
  instrument_account_number?: string;
  notification_email?: string;
  customer_id?: number;
  customer_wallet_id?: number;
}

export interface PayResponse {
  payment_item_id: string;
  status: string;
  processed_at: string;
  error: string | null;
}

function isValidPayResponse(response: any): response is PayResponse {
  return (
    response &&
    typeof response === "object" &&
    typeof response.payment_item_id === "string" &&
    typeof response.status === "string" &&
    typeof response.processed_at === "string" &&
    "error" in response
  );
}

export const usePayMutation = ({
  authorisation = "",
}: {
  authorisation: string;
}) => {
  const navigate = useNavigate();

  return useMutation(
    async (payload: PaymentPayload) => {
      const response = await httpClient("payment/pay", {
        authorisation,
      }).post(payload);
      if (!isValidPayResponse(response)) {
        throw new Error("Invalid payment response format");
      }

      if (response.error) {
        throw new Error(
          typeof response.error === "string" ? response.error : "Payment error"
        );
      }

      return response;
    },
    {
      onSuccess: data => {
        navigate(`transaction/${data.payment_item_id}`);
      },
      onError: (error: any) => {
        console.error("Erreur lors du paiement", error);
      },
    }
  );
};
